export default __webpack_public_path__ + "3d448b509eb63e278b4b86d9af7a4106.svg";